module.exports = __webpack_public_path__ + "img/vietnam.d92d2299.svg";